module.exports = __webpack_public_path__ + "static/img/1-3.9a694cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1-3.jpg
// module id = YN6/
// module chunks = 0